import React, {useState, useEffect} from "react";
import axios from "axios";

export default ({handle}) => {

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState();

  useEffect(() => {
    getPage();
  }, [handle])

  const getPage = async () => {
    setLoading(true);
    const response = await axios.get(`/pages/${handle}.json`);
    setPage(response.data?.page);
    setLoading(false);
  }

  function createMarkup() { return {__html: page?.body_html}; };

  return <div>
      {!loading && page ?
        <div dangerouslySetInnerHTML={createMarkup()} />
        :
        <pill-loader class="pill-loader" aria-busy={true}></pill-loader>
      }
    </div>;
}
